import * as React from 'react';
import { Props } from 'react';
import moment from 'moment';
import i18next from 'i18next';

import './DialogView.scss';

interface WeatherDialogViewProps extends Props<WeatherDialogView> {

}

export class WeatherDialogView extends React.Component<WeatherDialogViewProps> {
    render() {
        return (
            <div className='dialog-container'>
                <div className='dialog-client-message'>
                    {i18next.t('weather_in_moscow')}
                </div>
                <div className='clearfix' />
                <div className='weather-dialog-bot-message'>
                    <div className='weather-dialog-cards-container'>
                        {[moment().format('DD.MM.YYYY'), moment().add(1, 'day').format('DD.MM.YYYY')].map((item, i) => <div key={i} className='weather-dialog-card'>
                            <div className='weather-dialog-card-icon' />
                            <div className='weather-dialog-card-title'>
                                {i18next.t('forecast_on_day', { day: item })}
                            </div>
                            <div className='weather-dialog-card-info'>
                                {i18next.t('overcast_rain')}
                            </div>
                            <div className='weather-dialog-card-temp' dangerouslySetInnerHTML={{ __html: i18next.t('temperature') }} />
                            <div className='weather-dialog-card-button'>
                                {i18next.t('more_info')}
                            </div>
                        </div>)}
                    </div>
                </div>
                <div className='clearfix' />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/CleverBot/Home/Dialogs/WeatherDialogView.tsx